"use client";

import React from "react";

import Box from "@mui/material/Box";

import { convertComponentProps } from "~/components/global-navigation/helpers/convert-component-props";
import { getNavItemUrl } from "~/components/global-navigation/helpers/get-navItem-url";
import { NavItemWithMeta } from "~/components/global-navigation/types";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { optionContentId, optionItemId } from "../constants";
import { HiddenGlobalNavOptionContent } from "../hidden-global-nav-option-content/component";

import type { OffscreenNavigationProps } from "./types";

export const OffscreenNavigation: React.FC<OffscreenNavigationProps> = ({
  navigation,
  viewAllLabel,
}) => {
  return (
    <Box display="none" {...getTestAutomationProps("offscreen-navigation")}>
      {navigation?.map((navigationElement) =>
        navigationElement?.children?.map((navItemElement, index) => {
          const { specialLinks, bannerArray, url, urlSlug, children, meta, title } =
            convertComponentProps(navItemElement as NavItemWithMeta) ?? {};

          if (!specialLinks && !bannerArray && url && !children) {
            return (
              <a
                key={`${index}-${meta?.deliveryId}`}
                href={url ? getNavItemUrl(url) : `/${urlSlug}`}
                id={`${optionItemId}-${meta?.deliveryId}`}
                {...getTestAutomationProps("option")}
              >
                {title}
              </a>
            );
          }

          return (
            <HiddenGlobalNavOptionContent
              key={`${index}-${(navItemElement as NavItemWithMeta)?._meta?.deliveryId}-${optionContentId}`}
              navItem={convertComponentProps(navItemElement as NavItemWithMeta)}
              viewAllLabel={viewAllLabel}
            />
          );
        }),
      )}
    </Box>
  );
};
